<template>
  <div>
    <div class="d-flex justify-content-between">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 h3">
            <feather-icon
              icon="Link2Icon"
              size="20"
              class="mr-1"
            />
            Désynchronisation par scan
          </label>
        </div>
      </b-form-group>
      <div>
        <b-form-group>
          <label
            class="mr-1 h4"
            style="color:black"
          >Nombre de colis: {{ items.length }}</label>
        </b-form-group>
      </div>
    </div>

    <b-form-group label="Référence">
      <b-input-group class="input-group-merge">
        <b-input-group-prepend is-text>
          <feather-icon icon="MaximizeIcon" />
        </b-input-group-prepend>
        <b-form-input
          ref="scanInput"
          v-model="ref"
          placeholder="Scanner ou saisir la référence du colis"
          @change="desynchronizeOrder"
        />
      </b-input-group>
    </b-form-group>

    <b-card>
      <h4 class="mb-2">
        Colis désynchronisés
      </h4>
      <b-table
        hover
        :items="items"
        :fields="fields"
      >
        <template #cell(status)="data">
          <b-badge :variant="data.item.status === 'success' ? 'light-success' : 'light-warning'">
            {{ data.item.status === 'success' ? 'Désynchronisé' : 'Déjà désynchronisé' }}
          </b-badge>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BCard,
  BTable,
  BBadge,
} from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ok from '@/assets/audio/ok.mp3'
import alreadyScanned from '@/assets/audio/colis-deja-scanne.mp3'
import notexist from '@/assets/audio/notexist.mp3'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BCard,
    BTable,
    BBadge,
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'code', label: 'Référence colis' },
        { key: 'client', label: 'Destinataire' },
        { key: 'gouvernorat', label: 'Gouvernorat' },
        { key: 'adresse', label: 'Adresse de livraison' },
        { key: 'téléphone', label: 'Téléphone principal' },
        { key: 'status', label: 'Statut' },
      ],
      ref: '',
      ok,
      alreadyScanned,
      notexist,
    }
  },
  mounted() {
    this.$refs.scanInput.focus()
  },
  methods: {
    async desynchronizeOrder() {
      const orderId = this.ref.trim()
      if (!orderId) return

      // Check if already scanned in this session
      const alreadyInList = this.items.find(el => el.code === Number(orderId))
      if (alreadyInList) {
        this.showAlert('Colis déjà scanné')
        this.playAudio(alreadyScanned)
        return
      }

      try {
        const response = await axios.post('/api/orders/desynchronize/', {
          order_id: orderId,
        })

        const { data } = response

        if (data.already_desynchronized) {
          this.items.unshift({
            code: data.order.id,
            client: data.order.name,
            gouvernorat: data.order.governorate,
            adresse: data.order.address,
            téléphone: data.order.phone1,
            status: 'already',
          })
          this.showToast('warning', 'top-center', `Colis ${data.order.id} déjà désynchronisé`)
          this.playAudio(alreadyScanned)
        } else if (data.success) {
          this.items.unshift({
            code: data.order.id,
            client: data.order.name,
            gouvernorat: data.order.governorate,
            adresse: data.order.address,
            téléphone: data.order.phone1,
            status: 'success',
          })
          this.showToast('success', 'top-center', `Colis ${data.order.id} désynchronisé avec succès`)
          this.playAudio(ok)
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.showAlert('Colis non existant')
          this.playAudio(notexist)
        } else {
          const errorMessage = error.response?.data?.error || 'Erreur lors de la désynchronisation'
          this.showAlert(errorMessage)
          this.playAudio(notexist)
        }
      }

      this.ref = ''
      this.$nextTick(() => {
        this.$refs.scanInput.focus()
      })
    },
    async playAudio(payload) {
      const voice = new Audio(payload)
      voice.addEventListener('canplaythrough', () => {
        voice.play()
      })
    },
    async showAlert(text) {
      try {
        await this.$swal({
          title: 'Alerte',
          icon: 'warning',
          text,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      // eslint-disable-next-line no-empty
      } catch (e) {}
      this.ref = ''
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        { position },
      )
    },
  },
}
</script>
